import { useEffect } from "react";
function useSyncMediaPlayers(leadingPlayerRef, instancesRef, isLoading) {
    useEffect(() => {
        if (isLoading)
            return;
        const leadingPlayer = leadingPlayerRef.current;
        const instances = instancesRef.current;
        if (!leadingPlayer || !instances?.length)
            return;
        const syncPlayers = (action, time) => {
            requestAnimationFrame(() => {
                const validInstances = instances.filter((player) => Boolean(player) && player !== leadingPlayer);
                validInstances.map((player) => {
                    switch (action) {
                        case "play": {
                            if (player.paused) {
                                player.play().catch(() => setTimeout(() => player.play(), 500));
                            }
                            break;
                        }
                        case "pause": {
                            if (!player.paused)
                                player.pause();
                            break;
                        }
                        case "seek": {
                            const shouldSeek = time !== undefined && Math.abs(player.currentTime - time) > 0.05;
                            if (shouldSeek) {
                                player.currentTime = time;
                            }
                            break;
                        }
                    }
                });
            });
        };
        const handlePlay = () => syncPlayers("play");
        const handlePause = () => syncPlayers("pause");
        const handleSeek = () => syncPlayers("seek", leadingPlayer.currentTime);
        const handleCanPlay = () => syncPlayers("play");
        leadingPlayer.addEventListener("play", handlePlay);
        leadingPlayer.addEventListener("pause", handlePause);
        leadingPlayer.addEventListener("seeked", handleSeek);
        const validInstances = instances.filter((player) => Boolean(player));
        validInstances.map((player) => {
            player.addEventListener("canplay", handleCanPlay);
        });
        const interval = setInterval(() => {
            syncPlayers("seek", leadingPlayer.currentTime);
        }, 1000);
        return () => {
            clearInterval(interval);
            leadingPlayer.removeEventListener("play", handlePlay);
            leadingPlayer.removeEventListener("pause", handlePause);
            leadingPlayer.removeEventListener("seeked", handleSeek);
            validInstances.map((player) => {
                player.removeEventListener("canplay", handleCanPlay);
            });
        };
    }, [leadingPlayerRef, instancesRef, isLoading]);
}
export default useSyncMediaPlayers;
